import { useCallback } from 'react'

import useRequireLogin from 'Pods/ThreeDStudio/Hooks/useRequireLogin'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import downloadImage from 'Pods/ThreeDStudio/Services/downloadImage'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { openPaidFeatureModal } from 'Pods/ThreeDStudio/Store/actions/ui'

// Saving a community image needs an account first, then the same premium entitlement as the
// studio's own download button, export, DCC bridge and private mode. The save runs entirely
// in the browser, so this is the only gate there is.
//
// The control stays enabled while locked: the click is what opens the upsell. The tier
// hydrates from /load-services.js after mount and is null until it lands, which reads as
// locked - prompting to subscribe is the safe way to be wrong, since the alternative hands
// the file to someone who may not be entitled to it.
function useImageDownload() {
  const t = useTranslation()
  const requireLogin = useRequireLogin('login')
  const hasPremiumFeatures = useThreeDStudioStore(state => state.subscription.premiumFeatures) === true

  const handleImageDownload = useCallback((image) => {
    if (!requireLogin()) return

    if (!hasPremiumFeatures) {
      openPaidFeatureModal()
      return
    }

    downloadImage(image.src, `cgtrader-ai-image-${image.id}`, t('imageGallery.downloadFailed'))
  }, [hasPremiumFeatures, requireLogin, t])

  return handleImageDownload
}

export default useImageDownload
